import React from 'react'

function Fifth() {
  return (
    <section className='fifth'>
        <h1>Connecting Africa to the rest of the world</h1>
        <p>It’s the connections between us that power PayZone</p>
    </section>
  )
}

export default Fifth